import WeatherOptionState from './schema/WeatherOptionState';
import { createStore } from 'satcheljs';

import '../../orchestration/addToWeatherListOrchestrator';

export default createStore<WeatherOptionState>('weatherOption', {
    weatherEnabled: null,
    weatherUnit: null,
    weatherLocations: null,
    weatherErrorState: null,
    weatherErrorLocationName: null,
});
